const accordion = (block = document) => {
  const tabClass = '.accordion__tab';
  const tabElements = block?.querySelectorAll(tabClass);

  function closeAllTabs(excludedEl) {
    tabElements.forEach((tabEl) => {
      if (tabEl !== excludedEl) {
        // eslint-disable-next-line no-param-reassign
        tabEl.open = false;
      }
    });
  }

  tabElements.forEach((tabEl) => {
    tabEl.addEventListener('click', (e) => {
      const currentTabEl = e.target.closest(tabClass);

      closeAllTabs(currentTabEl);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds/accordion', ($block) => {
      accordion($block[0]);
    });
  }
});

export default accordion;
